export const ADD_LIST = 'ADD_LIST'
export const USER_INFO = 'USER_INFO'
export const SET_GROUP = 'SET_GROUP'
export const CREATE_GROUP = 'CREATE_GROUP'
